













import { AccessLevel } from '@/modules/access-policy/constants/access-levels.constants';
import { computed, defineComponent } from '@vue/composition-api';
import * as R from 'ramda';

export default defineComponent({
    name: 'AccessLevelDynamicBadge',
    props: {
        accessLevel: { type: String, required: true },
    },
    setup(props) {
        const accessLevelText = computed(() => {
            if (R.isNil(props.accessLevel)) return;

            switch (props.accessLevel) {
                case AccessLevel.SelectiveSharing:
                    return 'Authorized Access';
                case AccessLevel.Public:
                    return 'Public Access';
                default:
                    return null;
            }
        });

        return {
            accessLevelText,
            AccessLevel,
        };
    },
});
